<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad" class="consume-list-container">
                <van-cell v-for="(item, index) in integralLogList" :key="'consume' + index">
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <div class="consume-item-title">{{item.remarks}}</div>
                    </template>
                    <template #label>
                        <div class="consume-item-content">
                            <div class="consume-item-type">{{item.created_at}}</div>
                        </div>
                    </template>
                    <template #default>
                        <div :class="'consume-item-amount ' + (item.integral > 0 ? 'income' : 'expenditure')">{{item.integral > 0 ? '+' : ''}}{{item.integral}}</div>
                    </template>
                </van-cell>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import api from '../../assets/js/api'

    export default {
        name: 'ConsumeLog',
        data () {
            return {
                integralLogList: [],
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 15,
                },
            }
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/user_card/query_integral_log', Object.assign({}, self.params, {
                    user_card_id: this.$route.query.user_card_id, // 卡片ID
                })).then(res => {
                    if(res.data.length < self.params.page_size){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.integralLogList = [];
                    }

                    for(let index in res.data){
                        self.integralLogList.push(res.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/themeify.scss';
    .consume-list-container {
        .van-cell{
            .consume-item-icon {
                border-radius: 50%;
                background: #ed6a0c;
            }
            .consume-item-title {
                font-size: 14px;
                font-weight: bold;
            }
        }
    }
    *{
        @include themeify{
            .consume-item-amount{
                &.income{
                    color: themed('colorText');
                }
                &.expenditure{
                    color: black;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/card/IntegralLog.vue